<template>
  <div class="sj-panel-date">
    <div
      class="sj-panel-date-item-head"
      v-for="item in weekDayList"
      :key="`head_${item}`"
    >
      {{ numberDayMap[item] }}
    </div>
    <div
      :class="[
        'sj-panel-date-item',
        {
          'pre-month': dateItem.pre,
          'next-month': dateItem.next,
          'current-month': !dateItem.pre && !dateItem.next,
          'current-month-week': isWeek,
          current: dateItem.current && !dateItem.pre && !dateItem.next
        }
      ]"
      v-for="dateItem in dateList"
      :key="dateItem.date"
      @click="handleClick(dateItem)"
      @mouseenter="handleMouseenter(dateItem)"
      @mouseleave="handleMouseleave(dateItem)"
    >
      <div
        :class="[
          'sj-panel-date-item-inner',
          {
            'is-range': getItemIsRange(dateItem),
            'start-date': getItemIsStartOrEndDate(dateItem),
            'end-date': getItemIsStartOrEndDate(dateItem, 'end'),
            'row-start': dateItem.rowStart,
            'row-end': dateItem.rowEnd,
            'week-hover': hovering && dateItem.rowIndex === hoveringIndex,
            selected: getItemSelected(dateItem)
          }
        ]"
      >
        <span>{{ dateItem.label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import mixin from "./mixin";

export default {
  mixins: [mixin],
  props: {
    firstDayOfWeek: {
      type: Number,
      default: 0
    },
    isWeek: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formatMonth: "YYYY-MM",
      formatDay: "YYYY-MM-DD",
      numberDayMap: {
        0: "日",
        1: "一",
        2: "二",
        3: "三",
        4: "四",
        5: "五",
        6: "六"
      },
      rowNum: 6,
      weekDayList: [],
      dateList: [],
      hovering: true,
      hoveringIndex: -1
    };
  },
  computed: {
    formatValue() {
      const {
        value,
        range,
        multiple,
        isWeek,
        formatDay,
        formatDateTime
      } = this;
      if (!range) {
        const getValue = val => {
          if (!isWeek) {
            if (typeof val === "number") {
              return moment(val).format(formatDay);
            }
            return "";
          } else {
            if (typeof val === "number") {
              const startDate = moment(val);
              return [
                formatDateTime(startDate),
                formatDateTime(startDate.add(6, "days"))
              ];
            }
            return [];
          }
        };
        if (!multiple) {
          return getValue(value);
        } else {
          if (Array.isArray(value)) {
            return value.map(item => getValue(item));
          }
          return [];
        }
      } else {
        if (
          Object.prototype.toString.call(value) === "[object Array]" &&
          value[0] &&
          typeof value[0] === "number" &&
          value[1] &&
          typeof value[1] === "number"
        ) {
          return [formatDateTime(value[0]), formatDateTime(value[1])];
        }
        return [];
      }
    }
  },
  methods: {
    getDateList() {
      const { currentDate, formatMonth, formatDay, rowNum } = this;
      const currentMonth = moment(currentDate).format(formatMonth);
      const startDate = moment(currentMonth, formatMonth);
      const startDateStr = startDate.format(formatDay);
      const endDate = moment(currentMonth, formatMonth)
        .add(1, "months")
        .subtract(1, "days");
      const endDateTime = endDate.toDate().getTime();

      const currentStr = moment().format(formatDay);

      const dateList = [];

      this.getWeekDayList();
      const { weekDayList } = this;
      const startDateWeekDay = startDate.day();
      const dayIndex = weekDayList.indexOf(startDateWeekDay) || 7;
      for (let i = 0; i < rowNum * 7; i += 1) {
        const nowDate = moment(startDateStr, formatDay).subtract(
          dayIndex - i,
          "days"
        );
        const dateStr = nowDate.format(formatDay);
        const dateTime = nowDate.toDate().getTime();
        dateList.push({
          pre: i < dayIndex,
          next: dateTime > endDateTime,
          current: currentStr === dateStr,
          date: dateStr,
          rowIndex: Math.floor(i / 7),
          columnIndex: i % 7,
          rowStart: i % 7 === 0,
          rowEnd: i % 7 === 6,
          dateTime,
          label: nowDate.format("DD"),
          weekDay: nowDate.day(),
          weekDayStr: this.numberDayMap[nowDate.day()]
        });
      }
      this.dateList = dateList;
    },
    getWeekDayList() {
      const { firstDayOfWeek } = this;
      const weekDayList = Array.from({ length: 7 }).map((item, index) => index);
      this.weekDayList = weekDayList
        .slice(firstDayOfWeek)
        .concat(weekDayList.slice(0, firstDayOfWeek));
    },
    formatDateTime(time) {
      const { formatDay } = this;
      return moment(moment(time).format(formatDay), formatDay)
        .toDate()
        .getTime();
    },
    handleClick(item) {
      const { range, multiple, value } = this;
      if (!range) {
        let inputValue = item.dateTime;
        if (this.isWeek) {
          inputValue = moment(item.dateTime)
            .subtract(item.columnIndex, "days")
            .toDate()
            .getTime();
        }
        if (multiple) {
          const nowVal = Array.isArray(value) ? [...value] : [];
          const index = nowVal.indexOf(inputValue);
          if (index === -1) {
            nowVal.push(inputValue);
          } else {
            nowVal.splice(index, 1);
          }
          this.$emit("input", nowVal);
        } else {
          this.$emit("input", inputValue);
          this.$emit("close");
        }
      } else {
        const { choosing } = this;
        this.$emit("update:choosing", !choosing);
        if (!choosing) {
          this.$emit("input", [item.dateTime, item.dateTime]);
          this.$emit("update:chooseStartValue", item.dateTime);
        } else {
          this.$emit("close");
        }
      }
    },
    handleMouseenter(item) {
      const { choosing, chooseStartValue, isWeek } = this;
      if (isWeek) {
        this.hovering = true;
        this.hoveringIndex = item.rowIndex;
      }
      if (choosing) {
        const valueList = [chooseStartValue, item.dateTime].sort(
          (a, b) => a - b
        );
        this.$emit("input", valueList);
      }
    },
    handleMouseleave() {
      this.hovering = false;
      this.hoveringIndex = -1;
    },
    getItemIsRange(dateItem) {
      const { range, isWeek, multiple, formatValue } = this;
      if (range || (isWeek && !multiple)) {
        return (
          dateItem.dateTime >= formatValue[0] &&
          dateItem.dateTime <= formatValue[1]
        );
      }
      if (isWeek && multiple) {
        let flag = false;
        for (let i = 0; i < formatValue.length; i += 1) {
          if (
            dateItem.dateTime >= formatValue[i][0] &&
            dateItem.dateTime <= formatValue[i][1]
          ) {
            flag = true;
            break;
          }
        }
        return flag;
      }
      return false;
    },
    getItemIsStartOrEndDate(dateItem, type = "start") {
      const index = type === "start" ? 0 : 1;
      const { range, isWeek, multiple, formatValue } = this;
      if (range || (isWeek && !multiple)) {
        return formatValue[index] === dateItem.dateTime;
      }
      if (isWeek && multiple) {
        let flag = false;
        for (let i = 0; i < formatValue.length; i += 1) {
          if (formatValue[i][index] === dateItem.dateTime) {
            flag = true;
            break;
          }
        }
        return flag;
      }
      return false;
    },
    getItemSelected(dateItem) {
      const { range, isWeek, multiple, formatValue } = this;
      if (!(range || isWeek)) {
        if (!multiple) {
          return formatValue === dateItem.date;
        } else {
          let flag = false;
          for (let i = 0; i < formatValue.length; i += 1) {
            if (formatValue[i] === dateItem.date) {
              flag = true;
              break;
            }
          }
          return flag;
        }
      }
      return false;
    }
  },
  watch: {
    currentDate: {
      immediate: true,
      handler() {
        this.getDateList();
      }
    },
    firstDayOfWeek() {
      this.getDateList();
    }
  }
};
</script>

<style lang="less" scoped>
.sj-panel-date {
  text-align: center;
  padding: 5px 0;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  grid-template-rows: repeat(7, 30px);
  align-items: center;

  .sj-panel-date-item-head {
    .text("caption", "dark", "medium");
  }

  .sj-panel-date-item {
    .text("caption", "available");
    cursor: pointer;

    &.pre-month,
    &.next-month {
      color: @color-light;
    }

    &.current {
      color: @color-highlight;
    }

    .sj-panel-date-item-inner {
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;

      span {
        display: block;
        width: 24px;
        height: 24px;
        line-height: 24px;
        border-radius: 50%;
      }
    }

    &.current-month,
    &.current-month-week {
      &:hover {
        .sj-panel-date-item-inner:not(.selected):not(.start-date):not(.end-date) {
          span {
            background-color: @color-productlight;
          }
        }
      }

      .selected,
      .start-date,
      .end-date {
        span {
          background-color: @color-highlight;
          color: @color-antibg;
        }
      }

      .is-range {
        background-color: @color-productlight;

        &.start-date,
        &.end-date {
          background-color: transparent;
        }

        &.start-date:not(.end-date) {
          background: linear-gradient(
            to right,
            transparent 50%,
            @color-productlight 50%
          );
        }

        &.end-date:not(.start-date) {
          background: linear-gradient(
            to right,
            @color-productlight 50%,
            transparent 50%
          );
        }
      }

      .week-hover:not(.selected):not(.start-date):not(.end-date) {
        background-color: @color-productlight;

        span {
          background-color: @color-productlight;
        }

        &.row-start {
          background: linear-gradient(
            to right,
            transparent 50%,
            @color-productlight 50%
          );
        }

        &.row-end {
          background: linear-gradient(
            to right,
            @color-productlight 50%,
            transparent 50%
          );
        }
      }
    }
  }
}
</style>
